export default "__VITE_ASSET__Bp9S1ehS__"